/**
 * KORD sticky mobile add-to-cart bar.
 * Shows once the real product form scrolls out of view, hides once the
 * on-page add-to-cart button is visible again. Delegates the actual
 * add-to-cart action to the real product form so variant/quantity/cart
 * logic is never duplicated.
 */
(function () {
  var bar = document.getElementById('kord-sticky-atc');
  if (!bar) return;

  var formId = bar.getAttribute('data-product-form-id');
  var form = formId ? document.getElementById(formId) : null;
  var stickyButton = document.getElementById('kord-sticky-atc-button');
  var priceEl = document.getElementById('kord-sticky-atc-price');

  var realSubmit = form ? form.querySelector('[type="submit"]') : null;

  if (stickyButton && realSubmit) {
    stickyButton.addEventListener('click', function () {
      realSubmit.click();
    });
  }

  // Keep price in sync with variant changes broadcast by Dawn's variant picker.
  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || !priceEl) return;
    if (variant.price) {
      priceEl.textContent = (variant.price / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD',
      });
    }
    if (stickyButton) {
      stickyButton.disabled = !variant.available;
      stickyButton.textContent = variant.available
        ? stickyButton.getAttribute('data-add-label') || stickyButton.textContent
        : stickyButton.getAttribute('data-soldout-label') || stickyButton.textContent;
    }
  });

  // Toggle visibility based on whether the real add-to-cart button is on screen.
  var anchor = realSubmit || form;
  if (!anchor || !('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          bar.classList.remove('kord-visible');
        } else if (entry.boundingClientRect.top < 0) {
          bar.classList.add('kord-visible');
        } else {
          bar.classList.remove('kord-visible');
        }
      });
    },
    { threshold: 0 }
  );

  observer.observe(anchor);
})();
